import { render, staticRenderFns } from "./editIntegralShopRule.vue?vue&type=template&id=2e81af97"
import script from "./editIntegralShopRule.vue?vue&type=script&lang=js"
export * from "./editIntegralShopRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports